import { ButtonBase } from '@mui/material';

import { LegacyFAIcon } from '~/legacy-components/LegacyFAIcon';

import { useSxStyles } from './useStyles';

type Props = {
  faIcon: string;
  actionTitle: string;
  href?: string;
  onClick?: () => void;
};

export const UserProfileAction = ({
  faIcon,
  actionTitle,
  href,
  onClick,
}: Props) => {
  const sxStyles = useSxStyles();
  const action = href ? { href } : { onClick };

  return (
    <ButtonBase {...action} sx={sxStyles.link} disableRipple={true}>
      <LegacyFAIcon FAIcon={faIcon} sx={sxStyles.icon} />
      <span>{actionTitle}</span>
    </ButtonBase>
  );
};
